export const getProductRecommendations = async (
  $axios,
  $auth,

  product_id,
  limit,
) => {
  const params = {
    limit: limit || null,
    product_id,
  }

  const recommendationUrl = '/api/store/products/pdprecommendations/'
  try {
    return (await $axios.get(recommendationUrl, { params })).data.object_list
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const getWineTeam = async ($axios) => {
  try {
    return (
      await $axios.get('/api/catalog/oenologists/', {
        params: { 'wine-team': true },
      })
    ).data.results
  } catch (e) {
    console.error(e)
    throw e
  }
}
